import * as React from 'react';
import {Grid} from '@material-ui/core';
import Box from "@material-ui/core/Box";
import Help, { IHelp } from '../help/Help';
import { traducirMessage } from '../../blocks/traductor';

export interface ITipoRecoleccion {
    id: number
    nombre: string
    descripcion: string
    icono: string
    seleccionado: boolean
}

export interface Props {
    tipoRecoleccion: ITipoRecoleccion
    onClick: (id: number) => void
    esOrigen: boolean
    ayuda?: IHelp
}

const TipoRecoleccion = ({tipoRecoleccion, onClick, esOrigen, ayuda}: Props) => {
        let estilos = `pointer card normal-height ${tipoRecoleccion.seleccionado? 'selected': ''}`;

    return (<>
        <Grid container className={estilos} justify="center" onClick={() => onClick(tipoRecoleccion.id)}
              alignItems="center">
            <Grid item xs={3}>
                <Box display="flex" flexDirection="column" alignItems="center">
                    <Box>
                        <img src={"/image/" + tipoRecoleccion.icono} alt="icon"/>
                    </Box>
                </Box>
            </Grid>

            <Grid item xs>
                <Box display="flex" flexDirection="column" justifyContent="center">
                    <Box className="title-3">{tipoRecoleccion.nombre}</Box>
                    <Box className="title-4" flexGrow={1}>{tipoRecoleccion.descripcion}</Box>
                </Box>
            </Grid>
            <Grid item xs={1}>
                {
                    esOrigen 
                    ? 
                        <Box>
                            { tipoRecoleccion.id === 1 && <Help comments={traducirMessage(258)} customStyle={{ bottom: "1px", right: "-11px"}} size="small" /> }
                            { tipoRecoleccion.id === 2 && <Help comments={traducirMessage(259)} customStyle={{ bottom: "1px", right: "-11px"}} size="small" /> }
                            { tipoRecoleccion.id === 3 && <Help comments={traducirMessage(250)}customStyle={{ bottom: "1px", right: "-11px"}} size="small" /> }
                        </Box>
                    :   <Box>
                            { tipoRecoleccion.id === 1 && <Help comments={traducirMessage(256)} customStyle={{ bottom: "1px", right: "-11px"}} size="small" /> }
                            { tipoRecoleccion.id === 2 && <Help comments={traducirMessage(257)} customStyle={{ bottom: "1px", right: "-11px"}} size="small" /> }
                            { tipoRecoleccion.id === 3 && <Help comments={traducirMessage(251)} customStyle={{ bottom: "1px", right: "-11px"}} size="small" /> }
                        </Box>
                }
            </Grid>

        </Grid>
    </>)
};

export default TipoRecoleccion;
